import type { Locale } from './types'

export type MessageTree = string | { [key: string]: MessageTree }

export function getMessageString(
  tree: MessageTree | undefined,
  path: string,
): string {
  const parts = path.split('.')
  let cur: MessageTree | undefined = tree
  for (const p of parts) {
    if (cur === undefined || typeof cur === 'string') {
      return path
    }
    cur = cur[p]
  }
  return typeof cur === 'string' ? cur : path
}

export function createTranslator(messages: MessageTree) {
  return (path: string) => getMessageString(messages, path)
}

export const LOCALE_LABELS: Record<Locale, string> = {
  es: 'Español',
  en: 'English',
  pt: 'Português',
}
